export default __webpack_public_path__ + "static/media/Unit_15_thumb.86055b66.jpg";